import { DrupalMenuMachineName } from './ontario-header.enum';

export interface ApplicationHeaderInfo {
	title: string;
	href?: string;
	maxSubheaderLinks?: maxSubheaderLinks;
}

interface maxSubheaderLinks {
	desktop?: number;
	tablet?: number;
	mobile?: number;
}

export interface LanguageToggleOptions {
	englishLink: string;
	frenchLink: string;
}

export interface OntarioMenuItems {
	'href': string;
	'title': string;
	'drupal-menu-hierarchy': string[];
	'drupal-menu-machine-name': DrupalMenuMachineName[];
}

export type OntarioHeaderType = 'application' | 'ontario' | 'serviceOntario';

export type HeaderMenuOpenTrigger = 'click' | 'keyboard' | 'programmatic';

export interface HeaderMenuToggleDetail {
	isOpen: boolean;
	trigger: HeaderMenuOpenTrigger;
}
